
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule, DataModule } from '@/store'
import { emailRegex } from '@/helpers/email-validator'
import CFInput from '../inputs/CFInput'
import { phoneRegex } from '../../helpers/regex-helper'

	@Component({
	  name: 'ContactDetails'
	})
export default class ContactDetails extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		titleError = false;

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		// #region Methods

		setValue (val: number) {
		  this.value.title.id = val
		}

		submit () {
		  if (!this.validate()) {
		    return
		  }

		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  this.titleError = false

		  const ti = !!(this.value.title.id && this.value.title.id > 0)
		  const fn = (this.$refs.firstName as unknown as CFInput).validate()
		  const ln = (this.$refs.lastName as unknown as CFInput).validate()
		  const em = (this.$refs.email as unknown as CFInput).validate()
		  const pn = (this.$refs.contactNumber as unknown as CFInput).validate()

		  if (!ti) {
		    this.titleError = true
		  }

		  if (!ti || !fn || !ln || !em || !pn) {
		    setTimeout(() => {
		      const err = document.getElementsByClassName('error')
		      if (err.length > 0) {
		        (err[0] as HTMLDivElement).scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
		      }
		    }, 1)
		    return false
		  }

		  return true
		}

		previous () {
		  this.$emit('previous')
		  ApplicationModule.updateForm(ApplicationModule.formCopy)
		}

		// #endregion

		// #region Computed`

		get titles () {
		  return DataModule.titles
		}

		get emailRegexVal () {
		  return emailRegex
		}

		get phoneRegexVal () {
		  return phoneRegex
		}
		// #endregion
}
